import { render, staticRenderFns } from "./examTab.vue?vue&type=template&id=4d65b47c&scoped=true"
import script from "./examTab.vue?vue&type=script&lang=js"
export * from "./examTab.vue?vue&type=script&lang=js"
import style0 from "./examTab.vue?vue&type=style&index=0&id=4d65b47c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d65b47c",
  null
  
)

export default component.exports